// This file was auto-generated by commondatabuilder.
// Please don't edit it.

export const USER_ID_PREFIX = "justfix:";
